
import MachineFilesWidget from "./MachineFilesWidget";
import NetworkDiagramWidget from "../NetworkDiagram/NetworkDiagramWidget";
import CustomerGatewayWidget from "../NetworkGateway/CustomerGatewayWidget";
import MachineGatewayWidget from "../NetworkGateway/MachinGatewayWidget";
import ServiceCallWidget from "../ServiceCalls/ServiceCallsGridWidget";
import ServiceAgreementWidget from "../ServiceAgreements/ServiceAgreementGridWidget";
import MachineInfoWidget from "../MachineInfo/MachineInfoWidget";
import MachinePicturesWidget from "../MachinePictures/MachinePicturesWidget";
import WarrantyWidget from "../Warranties/WarrantyGridWidget";
import ServiceReportsWidget from "../ServiceReports/ServiceReportsGridWidget";
import SupportCasesWidget2 from "../SupportCases2/SupportCasesGridWidget";
import DeviceListWidget from "../DeviceList/DeviceListGridWidget";
import SparePartsWidget from "../Spareparts/SparepartsWidget";
import RunTimeWidget from "../RunTimes/RunTimeWidget";
import CustomersFilesWidget from "./CustomersFilesWidget";
import CustomerInfoWidget from "./CustomerInfoWidget";
import MachinesListWidget from "./MachinesListWidget";
import MachineDetailsWidget from "../MachineDetails/MachineDetailsWidget";
import CustomerTabStrip from "./TabStripCustomer";


export const dashboardCustomerWidgets = [
    <CustomerInfoWidget
      id="1001"
      header = "Customer Information"
      isBold = { true}
    />,
    <MachinesListWidget id="1002" header = "Machines" />,
    <CustomerGatewayWidget id="1003" header = "Remote Gateway Information" />,
    <CustomersFilesWidget id="1004" header = "Customer Files" />,
    <NetworkDiagramWidget id="1005" header = "Network Diagrams" thumb = { true} />,
    <ServiceCallWidget id="1006" header = "Service Calls" />,
    <ServiceAgreementWidget id="1007" header = "Service Agreements" />,
    <ServiceReportsWidget id="1008" header = "Archive Service Reports" />,
    <WarrantyWidget id="1009" header = "Warranties" />,
    <SupportCasesWidget2 id="10100" header = "Support Cases" />,
];
export const tabstripCustomerWidgets = [
    <CustomerInfoWidget id="100" header = "Customer Information" isBold = { true} />,
    <MachinesListWidget id="103" header = "Machines" />,
    <CustomerTabStrip id="2000" header = "Customer Tabs" />,
];
export const dashboardMachineWidgets = [
    <CustomerInfoWidget
      id="1001"
      header = "Customer Information"
      isBold = { false}
    />,
    <MachinesListWidget id="1002" header = "Machines" />,
    <MachineGatewayWidget id="2001" header = "Remote Gateway Information" />,
    <CustomersFilesWidget id="1004" header = "Customer Files" />,
    <NetworkDiagramWidget id="1005" header = "Network Diagrams" thumb = { true} />,

    <MachineDetailsWidget id="2010" header = "Assembly Details" />,
    <RunTimeWidget id="2002" header = "Assembly Device On/Run Time Totals" />,
    <DeviceListWidget id="2003" header = "Assembly Devices" />,

    <ServiceCallWidget id="1006" header = "Service Calls" />,
    <ServiceReportsWidget id="1008" header = "Archive Service Reports" />,
    <SupportCasesWidget2 id="10100" header = "Support Cases" />,

    <MachineFilesWidget id="2007" header = "Machine Files" />,
    <MachineInfoWidget id="2008" header = "Machine Info" />,
    <SparePartsWidget id="2009" header = "Spare part links" />,
    <MachinePicturesWidget id="2004" header = "Machine Pictures" />,
];